import { render, staticRenderFns } from "./hangzhou.vue?vue&type=template&id=424c8ff8&"
import script from "./hangzhou.vue?vue&type=script&lang=js&"
export * from "./hangzhou.vue?vue&type=script&lang=js&"
import style0 from "./hangzhou.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports